export default __webpack_public_path__ + "static/media/activeEnergyIcon.93ffa6fb.svg";